import { Route, Routes as BaseRoutes } from 'react-router-dom'
import ReviewRequest from './ReviewRequest'

const Routes = () => {
  return (
    <BaseRoutes>
      <Route
        element={<ReviewRequest />}
        path="/r/:requestSlug/:feedbackSlug?"
      />
    </BaseRoutes>
  )
}

export default Routes
